module.exports = __webpack_public_path__ + "static/media/avatar.c6f6bdd2.png";